<script>
  import Tooltip from '@components/general/tooltip.svelte'
  import { FileText, FileImage, FileMusic, FilePlay } from 'lucide-svelte'

  let { file, size = 16, showHint = true, tooltipProps = {}, ...iconProps } = $props()

  let Icon = $derived.by(() => {
    if (!file?.content_type) return FileText
    if (file?.content_type.startsWith('image/')) return FileImage
    if (file?.content_type.startsWith('audio/')) return FileMusic
    if (file?.content_type.startsWith('video/')) return FilePlay
    return FileText
  })

  let hint = $derived(showHint ? file?.content_type : null)
</script>

<Tooltip {hint} {...tooltipProps}>
  <Icon {size} {...iconProps} />
</Tooltip>